/*global angular,env */
'use strict';

angular.module('MrDWebApp')
  .controller('OrderDetailsCtrl', function($scope, $window, $cookies, storage, $http, $state, $stateParams, invoiceFactory, $previousState, $rootScope, order, orderFactory, $interval, $location, $timeout) {

    var _tracking_details = this;

    $previousState.memo('caller');

    $rootScope.$broadcast('loading:show');

    _tracking_details.hasLoaded = false;

    _tracking_details.previousState = $previousState.get('caller');

    _tracking_details.activeTab = 'receipt';
    if ($stateParams.view) _tracking_details.activeTab = $stateParams.view;

    //###################################################################################
    //  ORDER PROCESS - called only once when the order is loaded
    //###################################################################################
    
    _tracking_details.digestOrder = function() {
      $rootScope.$broadcast('loading:hide');

      _tracking_details.hasLoaded = true;
      
    };

    //###################################################################################
    //  ORDER PROCESS
    //###################################################################################

    if($scope._rc.trackingOrder && $scope._rc.trackingOrder.id === $stateParams.orderID){
      //Don't re-query the order... load from root scope.
      _tracking_details.order = $scope._rc.trackingOrder;
      _tracking_details.digestOrder();
    } else {
      _tracking_details.order = $scope._rc.trackingOrder = order; //injected `order` is a proimise
      _tracking_details.order.$promise.then(function () {
        _tracking_details.digestOrder();
      });
    }
  
    $scope._rc.bodyClass = 'html-details';

    _tracking_details.newOrderButtonClick = function(){

      $scope._rc.newOrderSoft();
      if ($scope._rc.variables.address.street_name){ // check for only street-name here. Assuming the rest..
        $state.go('location',{
          lat: $scope._rc.variables.address.latitude,
          lng: $scope._rc.variables.address.longitude,
          street_name: $scope._rc.variables.address.street_name
        });
      } else {
        if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
      }
  
    };

    _tracking_details.sendInvoice = function(){
      if(order.email === order.original){
        invoiceFactory.invoice(order.id);
      } else {
        invoiceFactory.invoiceAlternative(order.id,order.email);
      }
    };
  
    _tracking_details.promptSendInvoice = function(odr){
    
      $rootScope.$broadcast('global_message:show',{
        'name': 'send_invoice',
        'for_state': 'details',
        'error' : {
          'friendly_message': 'Send order invoice to the following email address.'
        },
        'confirm' : {
          'label': 'Send Invoice',
          'action': 'action',
          'value': {'id' : odr.id, 'email': odr.customer.email, 'original': odr.customer.email},
          'value_object': _tracking_details
        },
        'deny' : {
          'label': 'Cancel',
          'action': 'close',
          'value': true,
          'value_object': null
        }
      });
      
    };

});
